
<div>
  <div class="row">
    <div class="col ps-3">
      <h4 class="mb-0 font-header-1 mb-2">Discharge Code</h4>
    </div>
  </div>
  <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'|| global.globalAgencyId=='' ">
    <div class="row mt-4 ">
      <div class="col ">
        <div widget class="card border-0 box-shadow">
          <div class="card-body  widget-body pt-2">
            <div class="text-center text-danger">
              <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to
                view
                details</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- List -->
  <div *ngIf="global.globalAgencyId != null && global.globalAgencyId != '' && global.globalAgencyId != undefined && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'" class="row mt-4" >
    <div class="col">
      <div widget class="card border-0 box-shadow">
        <div class= "card-body widget-body pt-2">
          <div class="row mt-2">
            <div class="col-lg-4">
              <div class="col-lg-12">
                <label class="fw-bold">Filter By</label>
              </div>
              <div class="col-lg-12">
                <select [(ngModel)]="SearchColumn" class="form-select" (ngModelChange)="setDefaultValue()">
                  <option *ngFor="let item of filterItems | keyvalue" [ngValue]="item">{{ item.value }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4" *ngIf="SearchColumn.key != ''">
              <div class="col-lg-12">
                <label class="fw-bold">{{ SearchColumn.value }}</label>
              </div>
              <div class="col-lg-12">
                <input (keydown)="onKeydown($event)" type="text" class="form-control" [(ngModel)]="SearchText" />
              </div>
            </div>
            <!-- Apply -->
            <div class="col-lg-4">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn btn-primary btn-sm" (click)="Search()">Apply</button>
              </div>
            </div>
          </div>
          <div class="row mb-2 mt-2 ps-3 pe-3">
            <!-- Add Discharge Code -->
            <div class="col-lg-8">
              <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#modal"
               (click)="DischargeCreateUpdate('new')"  *ngIf="fp?.dccodescreate">
                Add Discharge Code
              </button>
            </div>
            <!-- Refresh -->
            <div class="col-lg-4 text-end">
              <button type="button" class="btn btn-primary btn-sm" (click)="Refresh()">
                <i class="fa fa-repeat"></i> Refresh
              </button>
            </div>
          </div>
          <div class="row ps-3 pe-3">
            <div class="col-lg-12">
              <ejs-grid #grid [dataSource]="data | async" [allowResizing]="true" (resizeStop)="onResize($event)"
                [allowPaging]="true" [pageSettings]="initialPage"
                (actionBegin)="onActionComplete($event)" [showColumnChooser]="true" (dataStateChange)="dataStateChange($event)">
                <e-columns>
                  <e-column minWidth="100" headerText="Actions" uid="action" textAlign="center" [showInColumnChooser]="false">
                    <ng-template #template let-data *ngIf="!changevalue">
                      <button class="btn btn-edit-table btn-sm" data-bs-toggle="modal" data-bs-target="#modal"
                        (click)="selectDischargedetails(data); DischargeCreateUpdate('edit');" *ngIf="fp?.dccodesupdate">
                        <i class="fa fa-edit" aria-hidden="true"></i>
                      </button>
                      &nbsp;
                      <button class="btn btn-delete-table btn-sm" data-bs-toggle="modal" data-bs-target="#deletemodal" 
                      (click)="selectDischargedetails(data)" *ngIf="fp?.dccodesdelete">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </ng-template>
                    <ng-template #template let-data *ngIf="changevalue">
                      <div class="form-check">
                        <input type="radio" (change)="selectDC(data)">
                      </div>
                    </ng-template>
                  </e-column>
                  <e-column minWidth="100" field="dischargeCode" headerText="Discharge Code">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth="100" field="codeDescription" headerText="Code Description">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width="50" [showInColumnChooser]="false">
                    <ng-template #headerTemplate let-data>
                      <div class="d-none d-lg-block">
                        <span id="show" (click)="show()">
                          <i class="fa fa-cog fa-lg" aria-hidden="true"></i>
                        </span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
          <div *ngIf="DischargeDataList.length == '00000000-0000-0000-0000-000000000000' && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'" class="text-center text-danger">
            <p>No data available</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

 <!-- //////////////////DELETE Model////////////// -->
<span id="openModal2" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" data-bs-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Record</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="deleteDischarge()"
        >
          Delete
        </button>
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

  
  <!-- ///////////////////////////////////////////////////// -->
  <!-- Modal Trigger -->
<span id="openModal1" data-bs-toggle="modal" data-bs-target="#modal"></span>

<!-- Modal -->
<div class="modal fade" id="modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg create-update-zip">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span *ngIf="ModelType === 'new'">Create Discharge Code</span>
          <span *ngIf="ModelType === 'edit'">Update Discharge Code</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Error Alert -->
        <div class="alert alert-warning" *ngIf="showErrorAlert">
          <strong>{{ error }}</strong>
        </div>

        <!-- Form -->
        <form [formGroup]="DischargeForm">
          <div class="mb-3 row">
            <label class="col-sm-6 col-form-label">Discharge Code <sup class="text-danger">*</sup></label>
            <div class="col-sm-6">
              <input 
                type="text" 
                class="form-control" 
                formControlName="DischargeCode" 
                [(ngModel)]="dccodes.dischargeCode" 
                name="dischargeCode" 
                (ngModelChange)="checkpopup('DischargeCode')"
              />
              <div class="text-danger" *ngIf="!DischargeForm.get('DischargeCode').valid && DischargeForm.get('DischargeCode').touched">
                Please Enter Discharge Code
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <label class="col-sm-6 col-form-label">Code Description <sup class="text-danger">*</sup></label>
            <div class="col-sm-6">
              <input 
                type="text" 
                class="form-control" 
                formControlName="Codedescription" 
                [(ngModel)]="dccodes.codeDescription" 
                name="codeDescription" 
                (ngModelChange)="checkpopup('CodeDescription')"
              />
              <div class="text-danger" *ngIf="!DischargeForm.get('Codedescription').valid && DischargeForm.get('Codedescription').touched">
                Please Enter Code Description
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button 
          class="btn btn-primary btn-sm" 
          (click)="SaveOrUpdateDischarge();" 
          [disabled]="!DischargeForm.valid"
        >
          <span *ngIf="ModelType === 'new'">Save & Close</span>
          <span *ngIf="ModelType === 'edit'">Update & Close</span>
        </button>
        <button 
          type="button" 
          class="btn btn-secondary btn-sm" 
          data-bs-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

  <!-- ==============close without save modal================================= -->
<span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#CloseModal"></span>
<div class="modal fade primarymodal" id="CloseModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm" (click)="closeAddUpdateModal()">Yes</button>
        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>